// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chatform .form-container .form-label {\n  margin-bottom: 0.2rem;\n}", "",{"version":3,"sources":["webpack://./src/client/element/core/InputElement.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ","sourcesContent":["#chatform .form-container {\n  .form-label {\n    margin-bottom: .2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
